import { createContext, FC, useCallback, useContext, useState } from 'react'
import {
  initialQueryRequest,
  QueryRequestContextProps,
  QueryState,
  WithChildren,
} from '../../../../../_metronic/helpers'

// Histórico "Novidades" do usuário: contexto próprio, separado da listagem admin.

const HistoricoQueryRequestContext = createContext<QueryRequestContextProps>(initialQueryRequest)

export const HistoricoQueryRequestProvider: FC<WithChildren> = ({ children }) => {
  const [state, setState] = useState<QueryState>(initialQueryRequest.state)

  const updateState = useCallback((updates: Partial<QueryState>) => {
    setState((prev) => ({ ...prev, ...updates }))
  }, [])

  return (
    <HistoricoQueryRequestContext.Provider value={{ state, updateState }}>
      {children}
    </HistoricoQueryRequestContext.Provider>
  )
}

export const useHistoricoQueryRequest = () => useContext(HistoricoQueryRequestContext)
